export default {
  namespaced: true,
  state: {
    alert: {
      type: null,
      message: null,
      title: null
    }
  },
  actions: {
    success({commit}, message) {
      commit("success", message);
    },
    error({commit}, message) {
      commit("error", message);
    },
    clear({commit}) {
      commit("clear");
    }
  },
  getters: {
    alert: state => state.alert
  },
  mutations: {
    success(state, message) {
      state.alert.type = "success";
      state.alert.message = message;
      state.alert.title = "Success";
    },
    error(state, message) {
      state.alert.type = "error";
      state.alert.message = message;
      state.alert.title = "Error";
    },
    clear(state) {
      state.alert.type = null;
      state.alert.message = null;
      state.alert.title = null;
    }
  }
};
